"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const UIRadio2_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UIRadio2.vue"));
const FilterValue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/FilterValue"));
const moment_1 = __importDefault(require("moment"));
const trans_1 = require("@common/tsutils/trans");
let OptValRange = class OptValRange extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.simple = '';
        this.from = '';
        this.to = '';
        this.subtype = 'range';
        this.options = [
            {
                value: 'simple',
                label: (0, trans_1.trans)('heatmap.type_options.value')
            },
            {
                value: 'range',
                label: (0, trans_1.trans)('heatmap.type_options.range')
            },
        ];
    }
    get placeholder_simple() {
        return (0, trans_1.trans)('heatmap.type_options.simple_date');
    }
    get placeholder_from() {
        return (0, trans_1.trans)('heatmap.type_options.from_date');
    }
    get placeholder_to() {
        return (0, trans_1.trans)('heatmap.type_options.to_date');
    }
    mounted() {
        const type = 'date_' + this.subtype;
        if (this.modelValue.type !== type) {
            this.emitValue();
            return;
        }
    }
    onChangeSubtype() {
        if (this.subtype === 'single') {
            this.from = '';
            this.to = '';
        }
        else {
            this.simple = '';
        }
    }
    emitValue() {
        if (this.subtype === 'simple') {
            this.emitSimpleDate();
        }
        else { // range
            this.emitRangeDate();
        }
    }
    momentOrNull(x) {
        if (x.trim() === '')
            return null;
        return (0, moment_1.default)(x, 'YYYY-MM-DD');
    }
    emitSimpleDate() {
        const a = this.momentOrNull(this.simple);
        if (a === null) {
            this.$emit('error', false);
            this.$emit('update:modelValue', FilterValue_1.default.newEmpty());
        }
        else if (!a.isValid()) {
            this.$emit('error', true);
        }
        else {
            this.$emit('error', false);
            this.$emit('update:modelValue', FilterValue_1.default.newDate(a.toDate()));
        }
    }
    emitRangeDate() {
        const a = this.momentOrNull(this.from);
        const b = this.momentOrNull(this.to);
        if (a === null && b === null) {
            this.$emit('error', false);
            this.$emit('update:modelValue', FilterValue_1.default.newEmpty());
            return;
        }
        if ((a !== null && !a.isValid()) || (b !== null && !b.isValid())) {
            this.$emit('error', true);
            return;
        }
        this.$emit('error', false);
        this.$emit('update:modelValue', FilterValue_1.default.newDateRange(a ? a.toDate() : null, b ? b.toDate() : null));
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], OptValRange.prototype, "modelValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('subtype')
], OptValRange.prototype, "onChangeSubtype", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('simple'),
    (0, vue_property_decorator_1.Watch)('from'),
    (0, vue_property_decorator_1.Watch)('to')
], OptValRange.prototype, "emitValue", null);
OptValRange = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            UIRadio2: UIRadio2_vue_1.default
        }
    })
], OptValRange);
exports.default = OptValRange;
